export function controlsFromList(list: any, control: any = []) {
  return list
    ? list.reduce((n: any, item: any) => {
        n[item.id] = typeof control == 'function' ? control(item) : control;
        return n;
      }, {})
    : {};
}
